import { pushGaData } from '../common';
let hoverGaEvent;
export const navigate = (event, setSection, setLocation) => {
    setSection(null);
    setLocation(event);
};
export const handleClickOrHover = (event, menuItem, isLoggedIn, setSection, setCallBack, setLocation) => {
    if (!isLoggedIn && !menuItem.children && menuItem.requireAuth && event.type === 'click') {
        setSection('sso');
        event.preventDefault();
        const targetHref = `${event.currentTarget.href}`;
        setCallBack(() => {
            window.location.assign(targetHref);
        });
    }
    else if (!menuItem.children && event && event.type === 'click') {
        navigate(event, setSection, setLocation);
    }
    if (!menuItem.children && !menuItem.parent && menuItem.classes && event.type === 'click') {
        pushNavGa(menuItem.label);
    }
};
const pushNavGa = (label) => pushGaData({
    eventAction: `Header Menu Item Open - ${label}`,
    eventLabel: 'Open'
});
export const handleOnToggle = (isOpen, menuItem) => {
    clearTimeout(hoverGaEvent);
    if (isOpen) {
        if (window.innerWidth < 1000) {
            hoverGaEvent = setTimeout(() => pushNavGa(menuItem.mobileLabel || menuItem.label), 2000);
        }
        if (menuItem.children && window.innerWidth >= 1000) {
            hoverGaEvent = setTimeout(() => pushNavGa(menuItem.label), 2000);
        }
    }
};
//# sourceMappingURL=HeaderNavItemEvents.js.map